import { FlexColumn, LabeledInput, MaterialIcon } from '@gorila-shared-ui/components';
import { HeadingLarge } from 'baseui/typography';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  user?: string | number;
  password?: string | number;
  onChangeUser?: (value: string) => void;
  onChangePass?: (value: string) => void;
  onSubmit?: () => void;
};

export function LoginForm({ onChangeUser, onChangePass, user, password, onSubmit }: Readonly<Props>) {
  const { theme } = useStyles();

  return (
    <FlexColumn gap={theme.sizing.scale600}>
      <HeadingLarge
        color={'rgb(30,41,59)'}
        margin={0}
      >
        Inicio de sesión
      </HeadingLarge>
      <LabeledInput
        placeholder={'Usuario'}
        value={user}
        onChange={onChangeUser}
        size={'default'}
        startEnhancer={<MaterialIcon name="account_circle" />}
      />
      <LabeledInput
        placeholder={'Contraseña'}
        value={password}
        onChange={onChangePass}
        type="password"
        size={'default'}
        autocomplete="current-password"
        startEnhancer={<MaterialIcon name="lock" />}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            onSubmit?.();
          }
        }}
      />
    </FlexColumn>
  );
}
